export enum CargoPaymentPreviewStatusEnum {
  OK = 'OK',
  CARGO_NOT_FOUND = 'CARGO_NOT_FOUND',
  WITHOUT_LICENSE_PLATE = 'WITHOUT_LICENSE_PLATE',
  VEHICLE_NOT_FOUND = 'VEHICLE_NOT_FOUND',
  WITHOUT_BANK_ACCOUNT = 'WITHOUT_BANK_ACCOUNT',
  PAYMENT_IN_PROGRESS = 'PAYMENT_IN_PROGRESS',
  PENDING_ADVANCE = 'PENDING_ADVANCE',
  NEGATIVE_BALANCE = 'NEGATIVE_BALANCE',
  WITHOUT_AMOUNT = 'WITHOUT_AMOUNT',
}

/**
 * Respaldo local del texto de cada estado. El back envía `message` listo para
 * mostrar; este diccionario solo se usa cuando llega vacío.
 */
export enum CargoPaymentPreviewStatusDict {
  'OK' = 'Cuenta bancaria encontrada',
  'CARGO_NOT_FOUND' = 'El servicio no existe o no pertenece a la compañía',
  'WITHOUT_LICENSE_PLATE' = 'El servicio no tiene vehículo asignado',
  'VEHICLE_NOT_FOUND' = 'No existe el vehículo con esa placa',
  'WITHOUT_BANK_ACCOUNT' = 'El vehículo no tiene cuenta registrada para este tipo de pago',
  'PAYMENT_IN_PROGRESS' = 'Ya hay un pago de este tipo en curso',
  'PENDING_ADVANCE' = 'Hay un anticipo en procesamiento, debe confirmarse o anularse antes',
  'NEGATIVE_BALANCE' = 'El servicio quedó en negativo, se cruza contra los positivos del mismo conductor',
  'WITHOUT_AMOUNT' = 'No queda nada pendiente por pagar de este tipo',
}

export type CargoPaymentPreviewSeverity = 'success' | 'error' | 'warning';

/**
 * Los estados en `error` son problemas de datos que alguien debe corregir; los
 * de `warning` son situaciones normales del flujo de pagos.
 */
export const CARGO_PAYMENT_PREVIEW_SEVERITY: { [status: string]: CargoPaymentPreviewSeverity } = {
  [CargoPaymentPreviewStatusEnum.OK]: 'success',
  [CargoPaymentPreviewStatusEnum.CARGO_NOT_FOUND]: 'error',
  [CargoPaymentPreviewStatusEnum.WITHOUT_LICENSE_PLATE]: 'error',
  [CargoPaymentPreviewStatusEnum.VEHICLE_NOT_FOUND]: 'error',
  [CargoPaymentPreviewStatusEnum.WITHOUT_BANK_ACCOUNT]: 'error',
  [CargoPaymentPreviewStatusEnum.PAYMENT_IN_PROGRESS]: 'warning',
  [CargoPaymentPreviewStatusEnum.PENDING_ADVANCE]: 'warning',
  [CargoPaymentPreviewStatusEnum.NEGATIVE_BALANCE]: 'warning',
  [CargoPaymentPreviewStatusEnum.WITHOUT_AMOUNT]: 'warning',
};
